import type { SiteConfig } from '../../@types/context/site-config.types';

export const contactZmartaFiConfig: Pick<SiteConfig, 'contact'> = {
  contact: {
    phone: '09 4241 4444',
    email: 'info@zmarta.fi',
  },
};
